export const ReportCardHandlerMenu = [
    {
      name:'شرایط درخواست‌دهنده',
      type:'profileRequired',
      active:true,
      id:1
    },
    {
      name:'سوالات اختصاصی',
      type:'requiredData',
      active:true,
      id:2
    },
    {
      name:'سنجش',
      type:'requiredQuiz',
      active:true,
      id:3
    },
    {
      name:'ارزیابی',
      type:'analysis',
      active:true,
      id:4
    }
  ]